export const INVOICES_UNPAID_ROUTE = 'unpaid';
export const INVOICES_PAID_ROUTE = 'paid';
export const INVOICES_TRANSACTION_HISTORY_ROUTE = 'transaction-history';
export const INVOICES_UNMATCHED_PAYMENTS_ROUTE = 'unmatched-payments';
export const INVOICES_MATCH_PAYMENT_ROUTE = 'match-payment';
